<template>
  <div class="businessRow">
    <div class="businessRowLeft">

      <div class="businessRowNav">

        <div class="businessRowNavBox">
          <div class="businessRowNavTitle">多元业务</div>
          <div class="businessRowNavMain">
            <a href="javascript:;" @mouseenter="navHover(index)" v-for="(item,index) in homeData.second" :class="{'active':item.check}" class="businessRowNavItem"><i class="iconfont" :class="item.icon"></i>{{item.title}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="businessRowRight">
      <div class="swiper-container businessSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in homeData.second">
            <a :href="item.linkurl">
              <img :src="item.service_image" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { indexData } from '@/api/web'

import "swiper/css/swiper.css"
import Swiper from 'swiper'
export default {
  data () {
    return {
      businessSwiper:'',
      pb: require('@/assets/img/pb1.jpg'),
      homeData:{}
    }
  },
  updated() {
      //实例更新完成
      this.businessSwiper.update();
  },
  mounted() {
      this.getData()
  },

  methods:{

    navHover(index){
      for(var i = 0; i < this.homeData.second.length; i++){
        this.homeData.second[i].check = false
      }
      this.homeData.second[index].check = true
      this.$forceUpdate()
      this.businessSwiper.slideTo(index);
    },

    getData(){
      indexData().then(res => {
        var _this = this
        this.homeData = res.data
        this.businessSwiper = new Swiper('.businessSwiper', {
            slidesPerView: 1,
            on: {


              slideChange: function () {
                var cutIndex = _this.businessSwiper.activeIndex
                for(var i = 0 ; i< _this.homeData.second.length; i++){
                  _this.homeData.second[i].check = false
                }

                _this.homeData.second[cutIndex].check = true
                _this.$forceUpdate()
              },
            },
        });

        if(this.homeData.second){
          for(var i = 0 ; i < this.homeData.second.length; i++){
            if(i == 0){
              this.homeData.second[i].check = true
            }else{
              this.homeData.second[i].check = false
            }

          }
        }
          // console.log(res.data.first,'sddds')

      })
    }



  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/userClass/service.vue